<template>
  <div class="return-table-container">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="serial_number" label="序列号" width="120"></el-table-column>
      <el-table-column prop="return_time" label="退回时间" width="120"></el-table-column>
      <el-table-column prop="return_person" label="退回人" width="100"></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" style="color: red;">未处理</span>
          <span v-else style="color: green;">已处理</span>
        </template>
      </el-table-column>
      <el-table-column prop="handler" label="处理人" width="100"></el-table-column>
      <el-table-column prop="handle_time" label="处理时间" width="120"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 1"
            type="primary"
            size="small"
            @click="handleProcess(scope.row)"
          >处理</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '../utils/api';

export default {
  data() {
    return {
      tableData: [],
      isNotifying: false,
      notificationInstance: null,
      reminderTimeout: null
    };
  },
  computed: {
    currentUser() {
      // 优先从 Vuex 获取用户信息
      let user = this.$store.state.user;
      // 如果 Vuex 中没有用户信息，则从 localStorage 获取
      if (!user) {
        const storedUser = localStorage.getItem('user');
        user = storedUser ? JSON.parse(storedUser) : {};
      }
      return user;
    }
  },
  mounted() {
    this.fetchData();
    setInterval(this.fetchData, 30000);
  },
  beforeDestroy() {
    if (this.reminderTimeout) {
      clearTimeout(this.reminderTimeout);
    }
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.getReturns();
        // 对数据按 return_time 降序排序
        this.tableData = res.data.sort((a, b) => {
          return new Date(b.return_time) - new Date(a.return_time);
        });
        this.checkNotifications();
      } catch (error) {
        this.$message.error('获取退回数据失败');
      }
    },
    async handleProcess(row) {
      try {
        // 获取当前登录用户的真实姓名
        const handler = this.currentUser.real_name || '未知用户';
        // 生成当前时间，格式为 YYYY-MM-DD HH:mm:ss
        const currentTime = new Date().toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).replace(/\//g, '-'); // 确保格式为 YYYY-MM-DD HH:mm:ss

        // 调用 API 更新状态、处理人和处理时间
        await api.updateReturnStatus(row.id, {
          status: 2,
          handler: handler,
          handle_time: currentTime
        });
        this.$message.success('处理成功');
        this.fetchData();
      } catch (error) {
        this.$message.error('处理失败');
      }
    },
    checkNotifications() {
      const unprocessed = this.tableData.filter(row => row.status === 1);
      if (unprocessed.length > 0 && !this.isNotifying) {
        this.showNotification(unprocessed.length);
      }
    },
    showNotification(unprocessedCount) {
      this.isNotifying = true;
      this.notificationInstance = this.$notify({
        title: '未处理退回记录提醒',
        message: `
          <div>
            <p>有 ${unprocessedCount} 条未处理的退回记录！</p>
            <div style="margin-top: 10px;">
              <button id="handleNow" style="background: #409EFF; color: white; border: none; padding: 5px 10px; margin-right: 10px; cursor: pointer; border-radius: 3px;">去处理</button>
              <button id="remindLater" style="background: #909399; color: white; border: none; padding: 5px 10px; cursor: pointer; border-radius: 3px;">稍后通知</button>
            </div>
          </div>
        `,
        type: 'warning',
        duration: 0,
        position: 'bottom-left',
        dangerouslyUseHTMLString: true,
        onClose: () => {
          this.isNotifying = false;
        }
      });

      setTimeout(() => {
        const handleNowBtn = document.getElementById('handleNow');
        const remindLaterBtn = document.getElementById('remindLater');
        if (handleNowBtn) {
          handleNowBtn.onclick = () => {
            this.handleNow();
            this.notificationInstance.close();
          };
        }
        if (remindLaterBtn) {
          remindLaterBtn.onclick = () => {
            this.remindLater();
            this.notificationInstance.close();
          };
        }
      }, 0);
    },
    handleNow() {
      this.$emit('switchToReturnTab');
      this.isNotifying = false;
    },
    remindLater() {
      this.isNotifying = false;
      if (this.reminderTimeout) {
        clearTimeout(this.reminderTimeout);
      }
      this.reminderTimeout = setTimeout(() => {
        const unprocessed = this.tableData.filter(row => row.status === 1);
        if (unprocessed.length > 0 && !this.isNotifying) {
          this.showNotification(unprocessed.length);
        }
      }, 5 * 60 * 1000);
    }
  }
};
</script>

<style scoped>
.return-table-container {
  height: 100%;
}
</style>
